import * as React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useLocation } from "react-router";
import {
  createUserChangeWatcher,
  resetPicksState,
} from "@/lib/picks/sessionReset";
import { supabase } from "@/providers/supabaseClient";

const LOGIN_PATH = "/login";

// Mounted once inside the router: whatever the previous operator left behind (query
// cache, unsaved-edit flags, write gate, pending command ids) must not reach the next.
export function PicksSessionReset(): null {
  const client = useQueryClient();
  const { pathname } = useLocation();

  const wipe = React.useCallback(() => {
    void client.cancelQueries();
    client.clear();
    resetPicksState();
  }, [client]);

  React.useEffect(() => {
    if (pathname === LOGIN_PATH) wipe();
  }, [pathname, wipe]);

  React.useEffect(() => {
    const watch = createUserChangeWatcher(wipe);
    const { data } = supabase.auth.onAuthStateChange((event, session) => {
      watch(event, session);
    });
    return () => {
      data.subscription.unsubscribe();
    };
  }, [wipe]);

  return null;
}
